module.exports = __webpack_public_path__ + "media/about_us/Janet-0f094293.png";